import React from 'react';
import { Linkify } from '../../../../../../common/components/Linkify';
import { LivechatMessageModel } from '@mm/state/model/LivechatMessageModel';

export const maybeHighlightText = (
  className: string,
  searchString: string,
  text: string | undefined,
  isRecursive?: boolean,
): React.ReactNode | null => {
  if (!text || !searchString) {
    return null;
  }

  const matchIndex = text.toLowerCase().indexOf(searchString.toLowerCase());
  if (matchIndex === -1) {
    return isRecursive ? <>{text}</> : <Linkify>{text}</Linkify>;
  }

  return (
    <>
      {text.slice(0, matchIndex)}
      <span className={className}>
        {text.slice(matchIndex, matchIndex + searchString.length)}
      </span>
      {maybeHighlightText(
        className,
        searchString,
        text.slice(matchIndex + searchString.length),
        true,
      ) || ''}
    </>
  );
};

export type SearchResultTextProps = {
  message: LivechatMessageModel;
  messageText: string;
  maybeGetRef?: (
    m: LivechatMessageModel,
  ) => React.Ref<HTMLDivElement> | undefined;
  getMatchHighlightClassName?: (m: LivechatMessageModel) => string;
  searchString?: string;
};

export const SearchResultText = ({
  message,
  messageText,
  maybeGetRef,
  getMatchHighlightClassName,
  searchString,
}: SearchResultTextProps) => {
  if (maybeGetRef && getMatchHighlightClassName && searchString !== undefined) {
    return (
      <div ref={maybeGetRef(message)}>
        {maybeHighlightText(
          getMatchHighlightClassName(message),
          searchString,
          messageText,
        )}
      </div>
    );
  }
  return null;
};
